import PropTypes from 'prop-types';
import React, { Component } from 'react';

import InlineValue from '../InlineValue';

export default class AssumptionValueDisplay extends Component {
  determineHiddenValue = (value) => {
    return <input id="checkBox" type="checkbox" checked={value === true || false} disabled />
  }

  displayFields = (hiddenValue, value) => {
    return ['hidden', 'description'].map((field, k) => {
      if (!hiddenValue && field !== 'hidden') return null;

      const fieldOverride = field === 'hidden' ? 'Torn' : 'Tearing Explanation';

      const fieldValue = value.get(field, null);
      const displayValue = typeof fieldValue === 'boolean' ? this.determineHiddenValue(fieldValue) : fieldValue;

      return (
        <div key={k}>
          <span className="badge badge-info mr-1">{fieldOverride}</span>
          <small>
            {displayValue || 'Unspecified'}
          </small>
        </div>
      );
    });
  };

  render() {
    const { value, toggleEditor, userMode } = this.props;

    const displayValue = (!value || !value.size || !value.has('hidden'))
      ? <div className="d-inline-block">Click to edit</div>
      : this.displayFields(value.get('hidden'), value);

    return (
      <InlineValue toggleEditor={toggleEditor} userMode={userMode}>
        <div className="d-inline-block">
          {displayValue}
        </div>
      </InlineValue>
    );
  }
}

AssumptionValueDisplay.propTypes = {
  toggerEditor:PropTypes.func,
  userMode: PropTypes.string,
  value: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/types/Assumption/AssumptionValueDisplay.js